import Icon from '../components/Icon.vue'

Icon.register({
  prescription: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M301.3 352l78.1 78c6.3 6.3 6.3 16.4 0 22.6l-22.6 22.6c-6.3 6.3-16.4 6.3-22.6 0l-78.1-78.1-78 78.1c-6.3 6.3-16.4 6.3-22.6 0l-22.6-22.6c-6.3-6.3-6.3-16.4 0-22.6l78.1-78.1-128-128h-18.8v80c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-256c0-8.8 7.2-16 16-16h144c53 0 96 43 96 96 0 48.9-36.7 88.8-84 94.8l84 84 78.1-78.1c6.3-6.3 16.4-6.3 22.6 0l22.6 22.6c6.3 6.3 6.3 16.4 0 22.6zM64 96v64h96c17.6 0 32-14.4 32-32s-14.4-32-32-32h-96z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/prescription.js
// module id = 1663
// module chunks = 0